<template>
  <div class="product-stats">
    <div :class="wrapperClass(item)" v-for="(item, i) in counterTypes" :key="i">
      <div class="product-stats__item"
           v-if="typeof isCounter(item.type) === 'number'">
        <img :src="item.icon ? item.icon : '/img/svgo/product-page/icon-eye-incircle.svg'" alt="icon" />
        <div class="product-stats__data">
          <p class="product-stats__data-content">
            {{ item.getData ? item.getData() :  $t('product_stats_left_count', { n: isCounter(item.type) })}}
          </p>
          <p class="product-stats__data-title">{{ item.title ? $t(item.title) : item.getTitle() }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wordFormatter } from '@/mixins/wordFormatter'

export default {
  name: 'ProductCounters',
  mixins: [wordFormatter],
  props: {
    counters: Array
  },
  data () {
    return {
      counterTypes: [
        {
          type: 'users_online',
          getData: () => this.computedTranslation(this.isCounter('users_online')),
          title: 'product_counters_online_now'
        },
        {
          type: 'users_today_viewing',
          getData: () => this.computedTranslation(this.isCounter('users_today_viewing')),
          getTitle: () => this.getViewCounterTitle('product_counters_today', 'users_today_viewing')
        },
        {
          type: 'users_online_viewing',
          getData: () => this.computedTranslation(this.isCounter('users_online_viewing')),
          getTitle: () => this.getViewCounterTitle('product_counters_at_the_moment', 'users_online_viewing')
        },
        {
          type: 'product_total_quantity',
          icon: '/img/svgo/product-page/icon-label-incircle.svg',
          title: 'product_counters_product_quantity'
        }
      ]
    }
  },
  methods: {
    computedTranslation (value) {
      return this.wordFormatter(value, [
        this.$t('product_stats_users_1', { n: value }),
        this.$t('product_stats_users_2', { n: value }),
        this.$t('product_stats_users_3', { n: value })
      ])
    },
    viewedTranslation (value) {
      if (value % 10 === 1) return this.$t('product_counters_viewed_2')
      else return this.$t('product_counters_viewed_1')
    },
    viewTranslation (value) {
      if (value % 10 === 1) return this.$t('product_counters_view_1')
      else return this.$t('product_counters_view_2')
    },
    isCounter (type) {
      const counter = this.counters.find(counter => counter.type === type)
      if (counter) return counter.value
      else return false
    },
    getViewCounterTitle (periodTranslationName, users) {
      const periodTranslation = this.$t(periodTranslationName)
      let verbTranslation = this.viewTranslation(this.isCounter(users))
      if (periodTranslationName === 'product_counters_today') verbTranslation = this.viewedTranslation(this.isCounter(users))
      const productTranslation = this.$t('product_counters_product')
      return `${periodTranslation} ${verbTranslation} ${productTranslation}`
    },
    wrapperClass (item) {
      if (typeof this.isCounter(item.type) !== 'number') return 'hide-wrapper'
      else return 'product-stats__wrapper'
    }
  }
}
</script>

<style scoped lang="sass">
.product-stats
  display: flex
  flex-flow: row wrap
  justify-content: flex-start
  &__item
    display: flex
  &__data
    display: flex
    flex-flow: column nowrap
    align-items: flex-start
    justify-content: center

    margin-left: 10px
    p
      margin: 0
    &-content
      font-size: 18px
      font-weight: 500
    &-title
      font-size: 13px
      font-weight: 400
      color: $placeholder-color

      margin-left: 10px

.product-stats__wrapper
  display: flex
  align-items: center
  justify-content: flex-start
  width: 100%
  min-width: 275px

  margin-bottom: 15px
  padding: 14px 14px 15px 14px

  background-color: #F8F8F8
  border-radius: 3px
  +mmin($small)
    width: 50%

  +mmin($tablet)
    width: 100%

  +mmin($large)
    width: 50%

.hide-wrapper
  display: none
</style>
